export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

const CONTENT_TYPE_TO_EXT: Record<string, string> = {
  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',
  'application/octet-stream': 'zip',
  'application/pdf': 'pdf',
};

/**
 * Deriva o nome do arquivo a partir dos headers HTTP da resposta.
 *
 * Ordem de prioridade:
 * 1. `Content-Disposition` com `filename*=` (RFC 5987, suporta UTF-8)
 * 2. `Content-Disposition` com `filename=`
 * 3. `Content-Type` → extensão via mapeamento
 * 4. `fallback` fornecido pelo chamador
 */
export function filenameFromResponse(response: Response, fallback: string): string {
  const disposition = response.headers.get('Content-Disposition');

  if (disposition) {
    const rfc5987 = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
    if (rfc5987) return decodeURIComponent(rfc5987[1].trim().replace(/['"]/g, ''));

    const basic = disposition.match(/filename=["']?([^"';\n]+)["']?/i);
    if (basic) return basic[1].trim();
  }

  const contentType = response.headers.get('Content-Type')?.split(';')[0].trim();
  if (contentType && CONTENT_TYPE_TO_EXT[contentType]) {
    const base = fallback.replace(/\.[^.]+$/, '');
    return `${base}.${CONTENT_TYPE_TO_EXT[contentType]}`;
  }

  return fallback;
}
